import { HttpClient } from '@angular/common/http'
import { computed, inject, Injectable, signal } from '@angular/core'
import { ShopBankOfferDto, StripeCheckoutDto } from '@mos/api/bank/dto-client'
import { BankService } from '@mos/client/shared/bank/services/bank.service'
import { catchError, Subject, tap } from 'rxjs'
import { ShopRepository } from '../shop.repository'

@Injectable({ providedIn: 'root' })
export class ShopService {
	private readonly http = inject(HttpClient)
	private readonly shopRepository = inject(ShopRepository)
	private readonly bankService = inject(BankService)

	// Which offer is mid-purchase, rather than a plain boolean: the shop renders many offer cards sharing
	// this one root-level service, and only the clicked one should show a pending state.
	readonly pendingOfferId = signal<number | null>(null)
	readonly paymentInitPending = computed(() => this.pendingOfferId() !== null)
	newCheckout$ = new Subject<StripeCheckoutDto>()

	getOffers() {
		return this.bankService.getOffers().pipe(tap((config) => this.shopRepository.setConfig(config)))
	}

	consumeOffer(offer: ShopBankOfferDto) {
		return this.bankService.consumeOffer(offer).pipe(
			tap((checkout) => {
				if (checkout !== undefined) {
					this.newCheckout$.next(checkout)
				}
				this.pendingOfferId.set(null)
			}),
			catchError((error) => {
				this.pendingOfferId.set(null)
				throw error
			}),
		)
	}

	consumeFreeOffer(offerId: number) {
		return this.http.post(`@api/bank/consume/free-offer/${offerId}`, {}).pipe(
			tap(() => {
				this.shopRepository.removeOffer(offerId)
				this.pendingOfferId.set(null)
			}),
			catchError((error) => {
				this.pendingOfferId.set(null)
				throw error
			}),
		)
	}

	consumeKeyOffer(offerId: number) {
		return this.http.post(`@api/bank/consume/key-offer/${offerId}`, {}).pipe(
			tap(() => {
				this.pendingOfferId.set(null)
			}),
			catchError((error) => {
				this.pendingOfferId.set(null)
				throw error
			}),
		)
	}
}
